import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import type { AssistantMessage } from '../../types/assistant';

interface Props {
  message: AssistantMessage;
}

export function AssistantBubble({ message }: Props) {
  const isUser = message.role === 'user';
  const containerCls = isUser ? 'justify-end' : 'justify-start';
  const bubbleCls = isUser
    ? 'bg-[#013125] text-white'
    : 'bg-white/4 text-white/90 border border-white/6';
  return (
    <div className={`flex w-full ${containerCls}`}>
      <div
        data-testid="assistant-bubble"
        data-role={message.role}
        className={`max-w-[85%] rounded-2xl px-3.5 py-2.5 text-[14px] leading-snug ${bubbleCls}`}
      >
        {isUser ? (
          <span className="whitespace-pre-wrap">{message.content}</span>
        ) : (
          // `prose-invert` gives light-on-dark text for the bubble; `prose-sm`
          // keeps the spacing compact; `max-w-none` lets it fill the bubble.
          <div className="prose prose-invert prose-sm max-w-none [overflow-wrap:anywhere] break-words">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{message.content}</ReactMarkdown>
          </div>
        )}
        {message.streaming ? (
          <span
            data-testid="assistant-cursor"
            aria-hidden="true"
            className="ml-1 inline-block h-3 w-[3px] animate-pulse bg-white/60 align-middle"
          />
        ) : null}
        {message.incomplete ? (
          <div className="mt-1.5 text-[11px] text-white/45 italic">Reply was interrupted.</div>
        ) : null}
      </div>
    </div>
  );
}
